import { Alert, Button, Form, InputNumber } from 'antd';
import type { DispatchAllocations } from '../dispatch.api';
import { toAllocations, type AllocationFields } from '../policies/dispatch-allocations.policy';

interface DispatchAllocationsFormProps {
  /** Why the button is off, in words; empty when the trip can go. */
  blockers: string[];
  isSubmitting: boolean;
  error: string | null;
  onDispatch: (allocations: DispatchAllocations) => Promise<void>;
}

const shillingsInput = <InputNumber min={0} className="w-full" prefix="KES" controls={false} />;

/** Fuel, the driver's advance and the expected tolls and weighbridge, then Dispatch. The server judges again when it is pressed. */
export function DispatchAllocationsForm({ blockers, isSubmitting, error, onDispatch }: DispatchAllocationsFormProps) {
  return (
    <section aria-label="Allocations" className="rounded-lg border border-line bg-surface p-5">
      <h2 className="mb-3 text-base font-semibold text-fg">Allocations</h2>
      <Form<AllocationFields> layout="vertical" onFinish={(fields) => onDispatch(toAllocations(fields))}>
        <div className="grid gap-x-4 sm:grid-cols-2">
          <Form.Item label="Fuel (litres)" name="fuelLitres">
            <InputNumber min={0} precision={0} className="w-full" controls={false} />
          </Form.Item>
          <Form.Item label="Driver advance" name="advance">
            {shillingsInput}
          </Form.Item>
          <Form.Item label="Expected tolls" name="tolls">
            {shillingsInput}
          </Form.Item>
          <Form.Item label="Expected weighbridge" name="weighbridge">
            {shillingsInput}
          </Form.Item>
        </div>
        {blockers.length > 0 && <Alert className="mb-3" type="warning" showIcon title="Not ready to dispatch" description={blockers.join(' ')} />}
        {error && <Alert className="mb-3" type="error" showIcon title={error} />}
        <Button type="primary" htmlType="submit" loading={isSubmitting} disabled={blockers.length > 0}>
          Dispatch
        </Button>
      </Form>
    </section>
  );
}
